import {
  useGetUserCommonMisconceptions,
  useDeleteCommonMisconception,
  getGetUserCommonMisconceptionsQueryKey,
  useGetTopCommonMisconceptions,
  likeCommonMisconception,
  unlikeCommonMisconception,
  getGetTopCommonMisconceptionsQueryKey,
} from "@packages/api/madlenAPI";
import MisconceptionCard from "../../components/misconceptions/MisconceptionCard";
import GenericToolPage from "../../components/tool_components/GenericToolPage";
import {
  AssessmentStrategies,
  MisconceptionItem,
} from "@packages/api/madlenAPI.schemas";

interface ExtendedTool {
  id: number;
  imageUrl?: string;
  prompt?: string;
  authorName?: string;
  likeCount?: number;
  courseName?: string;
  gradeLevel?: number;
  didUserLiked?: boolean;
  description?: string;
  createdAt?: string;
  isEditable?: boolean;
  title?: string;
  misconceptions?: MisconceptionItem[];
  assessmentStrategies?: AssessmentStrategies;
}

const MisconceptionDetailComponent = ({ tool }: { tool: ExtendedTool }) => {
  return (
    <MisconceptionCard misconception={tool} isEditable={tool.isEditable} />
  );
};

const MisconceptionsView = () => {
  return (
    <GenericToolPage
      useGetTools={useGetUserCommonMisconceptions}
      useDeleteTool={useDeleteCommonMisconception}
      getGetToolsQueryKey={getGetUserCommonMisconceptionsQueryKey}
      useGetTopTools={useGetTopCommonMisconceptions}
      likeTool={likeCommonMisconception}
      unlikeTool={unlikeCommonMisconception}
      getGetTopToolsQueryKey={getGetTopCommonMisconceptionsQueryKey}
      toolType="misconceptions"
      toolPath="misconceptions"
      DetailComponent={MisconceptionDetailComponent}
      colors={{
        light: "from-red-600 to-orange-600",
        dark: "dark:from-red-400 dark:to-orange-400",
        iconBg: "bg-red-100 dark:bg-red-900/50",
        iconColor: "text-red-600 dark:text-red-400",
        hover: "hover:bg-red-50 dark:hover:bg-red-900/20",
      }}
      toolColor="red"
      gradientColor="teal"
    />
  );
};

export default MisconceptionsView;
